'use client';

import H3 from '@/components/typography/h3';
import Label from '@/components/typography/label';
import Copiable from '@/components/ui/copiable';
import { useTranslation } from 'react-i18next';

export default function Rows() {
    const { t } = useTranslation();

    return (
        <div>
            <div className="flex flex-col items-center px-4 pt-2 pb-4 lg:px-0">
                <div className="flex w-full max-w-[1251px] flex-col">
                    <div className="flex w-full items-center border-t border-black py-5 lg:p-5">
                        <H3 className="w-1/2 lg:w-[65%]">
                            {t('rows.ourAddress')}
                        </H3>
                        <Copiable
                            label={t('info.address')}
                            value={t('info.addressLink')}
                        >
                            <Label className="underline hover:no-underline">
                                {t('info.address')}
                                <br />
                                {t('info.postalCode')}
                            </Label>
                        </Copiable>
                    </div>
                    <div className="flex w-full items-center border-t border-black py-5 lg:p-5">
                        <H3 className="w-1/2 lg:w-[65%]">
                            {t('rows.telephone')}
                        </H3>
                        <Copiable
                            label={t('info.phone')}
                            value={t('info.phone')}
                        >
                            <Label className="underline hover:no-underline">
                                {t('info.phone')}
                            </Label>
                        </Copiable>
                    </div>
                    <div className="flex w-full items-center border-y border-black py-5 lg:p-5">
                        <H3 className="w-1/2 lg:w-[65%]">{t('rows.email')}</H3>
                        <Copiable
                            label={t('info.emailAddress')}
                            value={t('info.emailAddress')}
                        >
                            <Label className="underline hover:no-underline">
                                {t('info.emailAddress')}
                            </Label>
                        </Copiable>
                    </div>
                </div>
            </div>
        </div>
    );
}
